export default __webpack_public_path__ + "static/media/Icons_Help_Blue Icon.91142501.svg";